import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors } from "../../redux/actions/productActions";
import { toast } from "react-toastify";
import Loader from "../loader/loader";
import { createMappingAction } from "../../redux/actions/upcScanActions";
import MappingList from "./MappingList";

const BarcodeMapping = () => {


    const dispatch = useDispatch();

    const { loading, error, message } = useSelector(state => state.mapping)

    const [parent_barcode, setParent_barcode] = useState("");
    const [child_barcode, setChild_barcode] = useState("");
    const [unit_case, setUnit_Case] = useState("");



    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const element = document.getElementById("addBarcodeMapping");

        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        element?.classList.add("activeHeaderLink");

        document.title = `Barcode Mapping - Admin Panel`;

    }, []);

    const handleSubmit = (e) => {

        e.preventDefault();

        if (!parent_barcode) {
            toast.error("Please enter case barcode");
            return;
        }

        if (!child_barcode) {
            toast.error("Please enter item barcode");
            return;
        }

        if (!unit_case) {
            toast.error("Please enter units per case");
            return;
        }
        if (Number(unit_case) < 1) {
            toast.error("Please enter valid units per case");
            return;
        }

        // ✅ Validate Parent Barcode
        const parentValidation = validateBarcode(parent_barcode);

        if (!parentValidation.success) {
            toast.error(parentValidation.message);
            return;
        }

        // ✅ Validate Child Barcode
        const childValidation = validateBarcode(child_barcode);

        if (!childValidation.success) {
            toast.error(childValidation.message);
            return;
        }

        const data = {
            parent_barcode: parentValidation.barcode,
            child_barcode: childValidation.barcode,
            unit_case
        };

        dispatch(createMappingAction(data));
    };


    useEffect(() => {


        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }
        if (message) {
            toast.success(message)
            dispatch({ type: "CREATE_MAPPING_RESET" })

            handleReset();
        }


    }, [error, message, dispatch])


    const handleReset = () => {

        setParent_barcode("");
        setChild_barcode("");
        setUnit_Case("");

    }

    const validateBarcode = (barcode) => {

        if (!barcode) {
            return {
                success: false,
                message: "Barcode is required"
            };
        }

        let upc = barcode.toString().trim();

        // Remove spaces
        upc = upc.replace(/\s/g, "");

        // Only digits allowed
        if (!/^\d+$/.test(upc)) {
            return {
                success: false,
                message: "Invalid barcode. Only numbers are allowed."
            };
        }

        // Allowed lengths only
        if (![8, 10, 11, 12, 13, 14].includes(upc.length)) {
            return {
                success: false,
                message: "Invalid barcode length."
            };
        }

        // Helper function for UPC check digit
        const generateUpcCheckDigit = (code11) => {

            let sum = 0;

            for (let i = 0; i < 11; i++) {

                const digit = parseInt(code11[i], 10);

                sum += (i % 2 === 0)
                    ? digit * 3
                    : digit;
            }

            return (10 - (sum % 10)) % 10;
        };

        // ==================================================
        // UPC-E (8 digit) -> UPC-A (12 digit)
        // ==================================================
        if (upc.length === 8) {

            const S = upc[0];
            const a = upc[1];
            const b = upc[2];
            const c = upc[3];
            const d = upc[4];
            const e = upc[5];
            const N = upc[6];

            let expanded;

            if (["0", "1", "2"].includes(N)) {
                expanded = `${S}${a}${b}${N}0000${c}${d}${e}`;
            }
            else if (N === "3") {
                expanded = `${S}${a}${b}${c}00000${d}${e}`;
            }
            else if (N === "4") {
                expanded = `${S}${a}${b}${c}${d}00000${e}`;
            }
            else {
                expanded = `${S}${a}${b}${c}${d}${e}0000${N}`;
            }

            const checkDigit = generateUpcCheckDigit(expanded);

            upc = expanded + checkDigit;
        }

        // ==================================================
        // 10 digit -> 11 digit -> 12 digit
        // Example:
        // 9050010019 -> 09050010019 -> 090500100195
        // ==================================================
        else if (upc.length === 10) {

            upc = "0" + upc;

            const checkDigit = generateUpcCheckDigit(upc);

            upc = upc + checkDigit;
        }

        // ==================================================
        // 11 digit -> 12 digit
        // Example:
        // 09050010019 -> 090500100195
        // ==================================================
        else if (upc.length === 11) {

            const checkDigit = generateUpcCheckDigit(upc);

            upc = upc + checkDigit;
        }

        // Final validation
        if (![12, 13, 14].includes(upc.length)) {
            return {
                success: false,
                message: "Invalid barcode format."
            };
        }

        return {
            success: true,
            barcode: upc
        };
    };

    return (
        <Fragment>
            <section className="pl-[1.5vmax] pr-[2.5vmax] ]">
                {loading && <Loader />}
                <div className="flex justify-between items-center bg-white p-[1.2vmax] rounded-[1vmax] px-[2vmax]">
                    <h2 className="text-[1.3vmax] font-bold">Barcode Mapping</h2>

                    <div className="flex-center gap-[0.8vmax] text-[1vmax]">
                        <Link to={"/"}>Dashboard</Link>
                        <div className="w-[0.3vmax] h-[0.3vmax] rounded-[50%] bg-black"></div>
                        <span className="text-slate-400">Barcode Mapping</span>
                    </div>
                </div>
            </section>


            <section className="pl-[1.5vmax] pr-[2.5vmax] mt-[1vmax] mb-[1vmax]">
                <div className="p-[2vmax] bg-white shadow-1 rounded-2xl">
                    <form onSubmit={handleSubmit} >
                        <h2 className="text-[1.5vmax] font-2 font-bold py-[2vmax]" >Add New Barcode Mapping</h2>
                        <div className="flex justify-start gap-[1.5vmax] items-center">
                            <div className=" w-[25%] flex flex-col gap-[0.5vmax]">
                                <span className="text-[1vmax] font-[600] text-gray-600" >Case Barcode &nbsp;
                                    <span className="text-red-600" >*</span>
                                </span>
                                <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Case Barcode"
                                    value={parent_barcode}
                                    onChange={(e) => setParent_barcode(e.target.value)}
                                />
                            </div>
                            <div className=" w-[25%] flex flex-col gap-[0.5vmax]">
                                <span className="text-[1vmax] font-[600] text-gray-600" >
                                    Units per Case&nbsp;
                                    <span className="text-red-600" >*</span>
                                </span>
                                <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Unit / Case"
                                    value={unit_case}
                                    onChange={(e) => setUnit_Case(e.target.value)}
                                />
                            </div>
                            <div className=" w-[25%] flex flex-col gap-[0.5vmax]">
                                <span className="text-[1vmax] font-[600] text-gray-600" >
                                    Item Barcode
                                    &nbsp;
                                    <span className="text-red-600" >*</span>
                                </span>
                                <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Item Barcode"
                                    value={child_barcode}
                                    onChange={(e) => setChild_barcode(e.target.value)}
                                />
                            </div>
                        </div>



                        <div className="flex justify-between gap-[1vmax] mt-10">
                            <span className="font-[500] text-gray-600 " >
                                <i class="fa-solid fa-circle-info"></i>
                                &nbsp;&nbsp;&nbsp;&nbsp;Fields with "<span className="text-red-600" > * </span>" are required</span>
                            <div className="flex gap-[1.5vmax]">
                                <button className="text-[1.1vmax] bg-gray-500 hover:bg-gray-700 text-white px-[1vmax] py-[0.5vmax] rounded-lg" type="button" onClick={handleReset} >Reset</button>
                                <button className="text-[1.1vmax] bg-green-600 hover:bg-green-700 text-white px-[1vmax] py-[0.5vmax] rounded-lg" type="submit" >Save </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
            <MappingList validateBarcode={validateBarcode} />
        </Fragment>
    );
};

export default BarcodeMapping;
